export const INSERT_TEXT_EDITOR_LINK = 'textEditor/INSERT_LINK';

export const insertTextEditorLink = payload => dispatch => {
  dispatch({
    type: INSERT_TEXT_EDITOR_LINK,
    payload,
  });

  return Promise.resolve();
};



// WEBPACK FOOTER //
// ./app/actions/insert-text-editor-link.js